import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Building2, Calendar, User, MapPin, Phone, Mail, Globe, Printer } from 'lucide-react';
import IntroductionTabs from '../../IntroductionTabs';
import './AboutUs.css';

const COMPANY_INFO = [
  { icon: Building2, label: '회사명', value: '주식회사 가까운물류' },
  { icon: Calendar, label: '설립', value: '2014년 1월 5일', sub: '(법인 전환: 2024년 5월 23일)' },
  { icon: User, label: '대표이사', value: '김종은' },
  { icon: MapPin, label: '본사 주소', value: '부산시 강서구 맥도길509번길 30' },
  { icon: Phone, label: '전화', value: '070-5089-3313' },
  { icon: Printer, label: '팩스', value: '051-941-4547' },
  { icon: Mail, label: '이메일', value: 'h0118899795@naver.com' },
  { icon: Globe, label: '홈페이지', value: 'www.가까운물류.com' },
];

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
  }, []);

  const canonical = 'https://www.xn--o39ap7bo6pk0bo2x.com/intro/about';
  const title = '회사소개 - 주식회사 가까운물류';
  const desc = '주식회사 가까운물류는 물류 파트너로써, 업무 효율화를 이루어 나가는 물류 전문회사입니다.';

  return (
    <div className="about-us-page">
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonical} />
        <meta name="description" content={desc} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="주식회사 가까운물류" />
        <meta property="og:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
      </Helmet>
      <IntroductionTabs type="company">
        <div tabId="about" className="about-us-content">

          {/* 1. 회사 정보 카드 (원래 디자인) */}
          <section className="about-company-info-section">
            <div className="about-company-info-card">
              {COMPANY_INFO.map((item, idx) => {
                const Icon = item.icon;
                return (
                  <div key={idx} className="about-company-info-row">
                    <div className="about-company-info-left">
                      <span className="about-company-info-icon">
                        <Icon size={20} strokeWidth={2} />
                      </span>
                      <span className="about-company-info-label">{item.label}</span>
                    </div>
                    <div className="about-company-info-right">
                      <span className="about-company-info-value">{item.value}</span>
                      {item.sub && <span className="about-company-info-sub">{item.sub}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

        </div>
      </IntroductionTabs>
    </div>
  );
};

export default AboutUs; 